export default {
  namespaced: true,
  state: {
    themeColor: localStorage.getItem('theme') || 'theme-light'
  },
  mutations: {
    CHANGE_THEME (state) {
      if (state.themeColor === 'theme-dark') {
        localStorage.setItem('theme', 'theme-light')
        state.themeColor = 'theme-light'
      } else {
        state.themeColor = 'theme-dark'
        localStorage.setItem('theme', 'theme-dark')
      }
    }
  },
  actions: {
    change_Theme (vuexInstance) {
      vuexInstance.commit('CHANGE_THEME')
    }
  },
  getters: {
    color: state => {
      return state.themeColor
    }
  }
}
